import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

export default function TypesMaca() {
    return (
        <section className="py-5">
            <Container>
                <h2 className="fs-3 mb-5 fw-bold make-serif text-center secondary-text"><span className="fw-light make-serif">4 Main Species of </span>Macademia Nuts</h2>
                <Row className="g-4">
                    <Col sm={12} md={5} >
                        <div className="intro-box mb-5">
                            <div className="intro-box-img">
                                <img src="/macademia-png.png" alt="Macademia Icon" />
                            </div>
                            <div className="intro-box-content ms-4">
                                <h6 className="fs-5 fw-medium">Macademia tetraphylla</h6>
                                <p className="small-text-01">Easily identified by four spiny leaves to each node and flowers are pink. Shells are bumpy or dimpled.</p>
                            </div>
                        </div>
                        <div className="intro-box mb-5">
                            <div className="intro-box-img">
                                <img src="/macademia-png.png" alt="Maxademia Icon" />
                            </div>
                            <div className="intro-box-content ms-4">
                                <h6 className="fs-5 fw-medium">Macademia ternifolia</h6>
                                <p className="small-text-01">It has leaves with spiny margins to each node, flowers and new flush are pink. The shells are small and smooth.</p>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={5} className="offset-lg-1">
                        <div className="intro-box mb-5">
                            <div className="intro-box-img">
                                <img src="/macademia-png.png" alt="Maxademia Icon" />
                            </div>
                            <div className="intro-box-content ms-4">
                                <h6 className="fs-5 fw-medium">Macademia jansenii</h6>
                                <p className="small-text-01">It has three leaves with smooth mairgins to each node, flowers are cream. The nuts are small and smooth.</p>
                            </div>
                        </div>
                        <div className="intro-box">
                            <div className="intro-box-img">
                                <img src="/macademia-png.png" alt="Maxademia Icon" />
                            </div>
                            <div className="intro-box-content ms-4">
                                <h6 className="fs-5 fw-medium">Macademia integrifolia</h6>
                                <p className="small-text-01">Seedling leaves can be very large and prickly, flowers are creamand the shells are smooth.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
